import Amplify from 'aws-amplify'

/**
 * AWS初期化
 * @param {string} country 国コード ※lib/aws/config下のファイル名と一致させること
 */
const init = (country) => {
  const config = loadConfig(country)
  Amplify.configure(config)
}

const loadConfig = (country) => {
  const configDir = './config/'
  let config
  try {
    config = require(`${configDir}${country}.js`)
  } catch(err) {
    // 国ごとに設定がない場合は日本環境の設定をロード
    config = require(`${configDir}jp.js`)
  }
  return config
}

export default {
  init,
}
